<template>
  <div
    @click="tryClose"
    data-notify="container"
    class="alert open"
    :class="[{ 'alert-with-icon': icon }, verticalAlign, horizontalAlign, alertType]"
    role="alert"
    :style="customPosition"
    data-notify-position="top-center"
  >
    <button
      v-if="showClose"
      type="button"
      aria-hidden="true"
      class="close col-xs-1"
      data-notify="dismiss"
      :style="closeButtonStyle"
      @click="close"
    >
      <i class="tim-icons icon-simple-remove"></i>
    </button>
    <span v-if="icon" data-notify="icon" :class="['alert-icon', icon]"></span>
    <span data-notify="message">
      <span v-if="title" class="title"
        ><b>{{ title }}<br /></b
      ></span>
      <span v-if="message" v-html="message"></span>
      <content-render
        v-if="!message && component"
        :component="component"
      ></content-render>
    </span>
    <span>
      <el-tooltip
        key="copyTooltip"
        content="Copy"
        :effect="themeSettings?.mode === 'dark' ? 'dark' : 'light'"
        :open-delay="400"
        placement="bottom"
        v-if="copy"
      >
        <button
          class="btn btn-simple ml-2 py-0 px-1"
          style="border: none"
          @click="
            () => {
              $handleCopyClick(link);
              $notifySuccess('Link copied to clipboard');
            }
          "
        >
          <i class="far fa-copy" style="font-size: 24px" />
        </button>
      </el-tooltip>
    </span>
    <button
      v-if="showAck"
      type="button"
      aria-hidden="true"
      class="btn-ack btn-sm"
      data-notify="ack"
      :style="ackButtonStyle"
      @click="ack"
    >
      Accept
    </button>
  </div>
</template>

<script>
import { Helpers } from '@/common/mixins/Helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'notification',
  mixins: [Helpers],
  components: {
    contentRender: {
      props: ['component'],
      render: h => h(this.component)
    }
  },
  props: {
    message: String,
    title: String,
    icon: String,
    link: String,
    copy: {
      type: Boolean,
      default: false
    },
    verticalAlign: {
      type: String,
      default: 'top',
      validator: value => {
        let acceptedValues = ['top', 'bottom'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    horizontalAlign: {
      type: String,
      default: 'right',
      validator: value => {
        let acceptedValues = ['left', 'center', 'right'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    type: {
      type: String,
      default: 'info',
      validator: value => {
        let acceptedValues = ['info', 'primary', 'danger', 'warning', 'success'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    timeout: {
      type: Number,
      default: 5000,
      validator: value => {
        return value >= 0;
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    timestamp: { type: Date, default: () => new Date() },
    component: { type: [Object, Function] },
    showClose: { type: Boolean, default: true },
    showAck: { type: Boolean, default: false },
    closeOnClick: { type: Boolean, default: true },
    clickHandler: Function,
    closeButtonStyle: String,
    ackButtonStyle: String
  },
  data() {
    return {
      elmHeight: 0
    };
  },
  computed: {
    ...mapGetters({themeSettings: 'getThemeSettings',}),
    hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType() {
      return `alert-${this.type}`;
    },
    customPosition() {
      let initialMargin = 20;
      let alertHeight = this.elmHeight + 10;
      let sameAlertsCount = this.$notifications.state.filter(alert => {
        return (
          alert.horizontalAlign === this.horizontalAlign &&
          alert.verticalAlign === this.verticalAlign &&
          alert.timestamp <= this.timestamp
        );
      }).length;
      if (this.$notifications.settings.overlap) {
        sameAlertsCount = 1;
      }
      let pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      let styles = {};
      if (this.verticalAlign === 'top') {
        styles.top = `${pixels}px`;
      } else {
        styles.bottom = `${pixels}px`;
      }
      return styles;
    }
  },
  methods: {
    ack() {
      this.$emit('ack', this.timestamp);
    },
    close() {
      this.$emit('close', this.timestamp);
    },
    tryClose(evt) {
      if (this.clickHandler) {
        this.clickHandler(evt, this);
      }
      if (this.closeOnClick) {
        this.close();
      }
    }
  },
  mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout && this.autoClose) {
      setTimeout(this.close, this.timeout);
    }
  }
};
</script>
<style lang="scss">
.notifications .alert {
  position: fixed;
  z-index: 10000;

  &[data-notify='container'] {
    width: 500px;
  }

  &.center {
    margin: 0 auto;
  }
  &.left {
    left: 20px;
  }
  &.right {
    right: 15px;
  }
}
.btn-ack {
  float: right;
  background: none;
  color: white;
  cursor: pointer;
  border: 1px solid white;
  outline: none;
}
.btn-ack:hover {
  color: black;
  opacity: 0.3;
  border: 1px solid black;
  outline: none;
}
.btn-ack:active {
  outline: none;
}
</style>
